import { qportalApi } from './qportal-api';
const emptyGuid = '00000000-0000-0000-0000-000000000000';
const getRegistrationContexts = (from, to) => {
    return qportalApi.get('hours-registration/contexts', {
        params: { from, to }
    });
};
const getContextWeek = (request) => {
    return qportalApi.get('hours-registration/week', {
        params: request
    });
};
const getHourTypesForContext = (request) => {
    return qportalApi.get('hour-types', {
        params: request
    });
};
const getDaysByMonthYearWeekNoAndAssignmentId = (dateMonthWeekNo) => {
    return qportalApi.postForm(`hoursRegistration/getWeekDaysByMonthYearWeekNoAndAssignmentId`, dateMonthWeekNo);
};
const getHoursByTimeSheetIdsForAdmin = (timeSheetIds) => {
    return qportalApi.get(`hoursRegistration/GetHoursByTimeSheetIds/${timeSheetIds}`);
};
const updateTimeSheetAndHourRegistrationStatus = (requestModel) => {
    return qportalApi.postForm(`hoursRegistration/UpdateTimeSheetAndHourRegistrationStatus/`, requestModel);
};
const registerHoursPerDay = (hoursLogged) => {
    // Do not use the generic object-to-form helper here: ClientAssignment is
    // enum value 0 and must not be dropped as a falsy value.
    const formData = new FormData();
    if (hoursLogged.id)
        formData.append('Id', hoursLogged.id);
    if (hoursLogged.expectedWeekVersion)
        formData.append('ExpectedWeekVersion', hoursLogged.expectedWeekVersion);
    formData.append('Year', String(hoursLogged.year));
    formData.append('Month', String(hoursLogged.month));
    formData.append('WeekNo', String(hoursLogged.weekNo));
    formData.append('AssignmentReasonId', hoursLogged.assignmentReasonId);
    if (hoursLogged.contextType !== undefined) {
        formData.append('ContextType', String(hoursLogged.contextType));
    }
    if (hoursLogged.contextId)
        formData.append('ContextId', hoursLogged.contextId);
    formData.append('AssignmentId', hoursLogged.assignmentId || emptyGuid);
    formData.append('Hours', String(hoursLogged.hours));
    formData.append('Date', hoursLogged.date);
    return qportalApi.postForm('hoursRegistration/registerHoursPerDay', formData);
};
const bulkRegisterHours = (hoursLogged) => {
    const payload = {
        hoursLogged: hoursLogged.map((h) => ({
            freelancerId: undefined,
            year: h.year,
            month: h.month,
            weekNo: h.weekNo,
            assignmentId: h.assignmentId,
            contextType: h.contextType,
            contextId: h.contextId,
            assignmentReasonId: h.assignmentReasonId,
            NoOfHours: h.NoOfHours,
            date: h.date,
            Id: h.Id,
            expectedWeekVersion: h.expectedWeekVersion
        }))
    };
    return qportalApi.post(`hoursRegistration/bulkRegisterHours`, payload);
};
const getLoggedHoursPerDayById = (Id) => {
    return qportalApi.get(`hoursRegistration/${Id}/GetLoggedHoursPerDayById`);
};
const GetMonthListByAssignmentAndFreelancerId = (request) => {
    return qportalApi.get(`hoursRegistration/GetMonthListByAssignmentAndFreelancerId`, {
        params: { assignmentId: request.assignmentId, year: request.year, id: request.id }
    });
};
const getYearListByAssignmentAndFreelancerId = (request) => {
    return qportalApi.get(`hoursRegistration/GetYearListByAssignmentAndFreelancerId`, {
        params: { assignmentId: request.assignmentId, id: request.id }
    });
};
const reSyncBusinessCentralHoursByTimeSheetIds = (timeSheetIds) => {
    return qportalApi.get(`hoursRegistration/ReSyncBusinessCentralHoursByTimeSheetIds/${timeSheetIds}`);
};
const HoursRegistrationApi = {
    getRegistrationContexts,
    getContextWeek,
    getHourTypesForContext,
    updateTimeSheetAndHourRegistrationStatus,
    registerHoursPerDay,
    getLoggedHoursPerDayById,
    getHoursByTimeSheetIdsForAdmin,
    bulkRegisterHours,
    getDaysByMonthYearWeekNoAndAssignmentId,
    GetMonthListByAssignmentAndFreelancerId,
    getYearListByAssignmentAndFreelancerId,
    reSyncBusinessCentralHoursByTimeSheetIds
};
export default HoursRegistrationApi;
